/**
 * Тексты уведомления: structured fields API + fallback message.
 */

/** Есть ли клиническая выжимка LLM (новый контракт API). */
export function hasStructuredClinicalFields(alert) {
    return Boolean(alert?.patient_summary_ru?.trim());
}

/** Основной абзац карточки — patient_summary_ru или legacy message. */
export function getAlertPrimarySummary(alert) {
    const summary = alert?.patient_summary_ru?.trim();
    if (summary) return summary;
    return alert?.message?.trim() || "";
}

/**
 * Превью для баннера/dock (одна строка).
 * Приоритет: patient_summary_ru, иначе клинический абзац из message.
 */
export function getNotificationPreviewLine(alertOrMessage) {
    if (alertOrMessage && typeof alertOrMessage === "object") {
        const summary = getAlertPrimarySummary(alertOrMessage);
        if (summary) {
            return summary.split("\n")[0]?.trim() ?? "";
        }
        return getNotificationPreviewLine(alertOrMessage.message);
    }

    const message = alertOrMessage;
    if (!message?.trim()) return "";

    const parts = message.trim().split(/\n\s*\n/);
    const body =
        parts.length > 1 ? parts.slice(1).join("\n\n").trim() : parts[0].trim();

    return body.split("\n")[0]?.trim() ?? "";
}

/** Уверенность LLM (0–1) → «85%» для мета-строки карточки. */
export function formatAlertConfidence(confidence) {
    if (typeof confidence !== "number" || Number.isNaN(confidence)) return null;
    const clamped = Math.min(1, Math.max(0, confidence));
    return `${Math.round(clamped * 100)}%`;
}
